package com.xtream.video_player

actual val DEFAULT_SURFACE_TYPE: Int
    get() = -1